/**
 * SEO component — page title and social meta via react-helmet-async.
 */

import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { getConfig } from '../utils/config'

function SEO({ description = ``, lang = `en`, meta = [], title }) {
  const siteTitle = `Watson Adventures App`
  const siteDescription = `Go on a scavenger hunt with Watson Adventures`
  const author = `Watson Adventures`
  const siteUrl = getConfig(`SITE_URL`) || `https://watsonadventures.com`
  const metaDescription = description || siteDescription

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${siteTitle}`}>
      <link rel="canonical" href={`https://watsonadventures.com/`} />
      <link rel="icon" href="/favicon-32x32.png" type="image/png" />
      <link rel="shortcut icon" href="/favicon-32x32.png" type="image/png" />
      <meta name="docsearch:version" content="2.0" />
      <meta name="viewport" content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover" />
      <meta name="description" content={metaDescription} />

      <meta property="og:url" content={`https://watsonadventures.com/`} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={lang} />
      <meta property="og:site_name" content={title} />
      <meta property="og:image" content={`${siteUrl}/images/watson.jpg`} />
      <meta property="og:image:width" content="1856" />
      <meta property="og:image:height" content="1856" />
      <meta property="og:description" content={metaDescription} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content={`https://watsonadventures.com/`} />
      <meta name="twitter:creator" content={author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />

      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="robots" content="noindex, nofollow, noarchive, nocache" />
    </Helmet>
  )
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
